export default "__VITE_ASSET__BunpN0b1__"